import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { config } from '@uhg-abyss/web/tools/config';
import { FLOW_ID } from '@src/common/AppConstants';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';

export const RCMRedirectModal = ({ isOpen }) => {
  const router = useRouter();
  const { token } = useParams();

  return (
    <Modal
      title="The company name you entered is recognized as a billing or vendor organization."
      isOpen={isOpen}
      onClose={() => {}}
      hideClose={true}
      closeOnClickOutside={false}
      size="md"
    >
      <Modal.Section>
        <p>
          You are required to use the{' '}
          <strong>billing company or vendor tax ID (TIN)</strong> to continue
          registration. This type of TIN <strong>cannot</strong> be used as a
          healthcare professional or facility registration.
        </p>
        <p>
          After registering, you can request access to provider TINs through 3rd
          party access. See the{' '}
          <Link
            href={config('THIRD_PARTY_ACCESS_GUIDE')}
            onClick={() => {
              adobeTaggingEvent('DOWNLOAD_CLICKS', {
                downloadFileName: '3rd Party Access Guide',
                fileUrl: config('THIRD_PARTY_ACCESS_GUIDE'),
                fileContext: 'self paced chameleon guide',
              });
            }}
          >
            3rd Party Access Guide
          </Link>{' '}
          for details.
        </p>
      </Modal.Section>
      <Modal.Section>
        <Flex
          css={{
            'abyss-flex-root': {
              gap: '16px',
              justifyContent: 'center',
            },
          }}
        >
          <Button
            variant="outline"
            onClick={() => {
              adobeTaggingEvent('RCM_CTA_CLICK', {
                interactionName:
                  'Company recognized as billing or vendor organization modal',
                interactionValue: 'Register with your Company',
                interactionContext:
                  'tin registration-healthcare professional or facility',
              });
              adobeTaggingEvent('COMPANY_VENDOR_MODAL_CLOSE', {
                modalName:
                  'Company recognized as billing or vendor organization modal',
              });
              router.navigate(`/TINValidation/${FLOW_ID.BILLING}/${token}`);
            }}
          >
            Register with your Company
          </Button>
          <Button
            variant="outline"
            onClick={() => {
              adobeTaggingEvent('RCM_CTA_CLICK', {
                interactionName:
                  'Company recognized as billing or vendor organization modal',
                interactionValue: 'Register as a Vendor',
                interactionContext:
                  'tin registration-healthcare professional or facility',
              });
              adobeTaggingEvent('COMPANY_VENDOR_MODAL_CLOSE', {
                modalName:
                  'Company recognized as billing or vendor organization modal',
              });
              router.navigate(`/TINValidation/${FLOW_ID.VENDOR}/${token}`);
            }}
          >
            Register as a Vendor
          </Button>
        </Flex>
      </Modal.Section>
    </Modal>
  );
};

RCMRedirectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
